import axios from 'axios';
import { handleNetworkError, handleRequestAuthHeader } from './tool';
import { ToastViewMessage } from '../utils/util';
import { Toast } from 'antd-mobile';

export interface CResponse<T> {
  code: string;
  msg: string;
  data: T;
}

export interface CListPagination {
  total: number; //总条数
  current_page: number; //当前页
  pages: number; //总页数
}

export interface CListData<T> {
  list: T[];
  pagation: CListPagination;
}

export interface CListResponse<T> {
  code: string;
  msg: string;
  data: CListData<T>;
}

export class CError extends Error {
  code: number;
  constructor(message: string, code: number) {
    super(message);
    this.code = code;
  }
}

const VUE_APP_DEV_URL: string = '/api';
const VUE_APP_PRO_URL: string = '//bbs.colg.cn';

const instance = axios.create({
  responseType: 'json',
  timeout: 1000 * 20,
  withCredentials: false, //跨域请求时是否需要使用凭证
  //baseURL: VUE_APP_PRO_URL
  baseURL:
    process.env.NODE_ENV === 'development' ? VUE_APP_DEV_URL : VUE_APP_PRO_URL,
  // baseURL: VUE_APP_DEV_URL
});

export const Get = <T>(
  url: string,
  params: any
): Promise<[any, CResponse<T> | undefined, CListResponse<T> | undefined]> =>
  new Promise((resolve) => {
    instance
      .get(url, { params })
      .then((result) => {
        // console.log(result.data.data['list'] as CListResponse<T>);
        resolve([
          null,
          result.data as CResponse<T>,
          result.data as CListResponse<T>,
        ]);
      })
      .catch((err: any) => {
        resolve([err, undefined, undefined]);
      });
  });

export const Post = <T>(
  url: string,
  params: any,
  data: any
): Promise<[any, CResponse<T> | undefined]> =>
  new Promise((resolve) => {
    instance
      .post(url, data, { params })
      .then((result) => {
        resolve([null, result.data as CResponse<T>]);
      })
      .catch((err: any) => {
        resolve([err, undefined]);
      });
  });

instance.interceptors.request.use((config) => {
  config = handleRequestAuthHeader(config);
  return config;
});

instance.interceptors.response.use(
  (response) => {
    if (response.data && response.data.code === 100000) {
      return response;
    } else {
      // ToastViewMessage(response.data.msg ?? '网络繁忙')
      // Toast.show(response.data.msg ?? '网络繁忙');
      Toast.show({ content: response.data.msg ?? '网络繁忙' });
      return Promise.reject(response);
    }
  },
  (err) => {
    handleNetworkError(err.response.status);
    Promise.reject(err.response);
  }
);
